import React from 'react';

const DashboardOverviewTab = ({ products, sliders, projects, inquiries, testimonials, banners, setActiveTab }) => {
    const stats = [
        {
            key: 'products',
            title: 'Active Products',
            count: (products && products.length) || 0,
            icon: 'fa-cubes',
            colorGrad: 'linear-gradient(135deg, #f03a02 0%, #ff6b35 100%)',
            shadow: '0 10px 25px rgba(240, 58, 2, 0.3)',
            badge: 'Manage Products Catalog'
        },
        {
            key: 'sliders',
            title: 'Hero Banner Slides',
            count: (sliders && sliders.length) || 0,
            icon: 'fa-sliders',
            colorGrad: 'linear-gradient(135deg, #0284c7 0%, #38bdf8 100%)',
            shadow: '0 10px 25px rgba(2, 132, 199, 0.3)',
            badge: 'Manage Carousel Sliders'
        },
        {
            key: 'projects',
            title: 'Completed Projects',
            count: (projects && projects.length) || 0,
            icon: 'fa-picture-o',
            colorGrad: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
            shadow: '0 10px 25px rgba(5, 150, 105, 0.3)',
            badge: 'Manage Projects Gallery'
        },
        {
            key: 'inquiries',
            title: 'Client Inquiries',
            count: (inquiries && inquiries.length) || 0,
            icon: 'fa-envelope',
            colorGrad: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
            shadow: '0 10px 25px rgba(124, 58, 237, 0.3)',
            badge: 'View Client Messages'
        },
        {
            key: 'testimonials',
            title: 'Testimonials',
            count: (testimonials && testimonials.length) || 0,
            icon: 'fa-star',
            colorGrad: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
            shadow: '0 10px 25px rgba(217, 119, 6, 0.3)',
            badge: 'Manage Reviews & Ratings'
        },
        {
            key: 'banners',
            title: 'Page Banners',
            count: banners ? Object.keys(banners).length : 0,
            icon: 'fa-flag',
            colorGrad: 'linear-gradient(135deg, #0f766e 0%, #2dd4bf 100%)',
            shadow: '0 10px 25px rgba(15, 118, 110, 0.3)',
            badge: 'Manage Page Hero Banners'
        }
    ];

    return (
        <div className="admin-tab-content">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '25px', padding: '10px 0' }}>
                {stats.map((item) => (
                    <div
                        key={item.key}
                        className="admin-stat-card-hover"
                        onClick={() => {
                            if (setActiveTab) setActiveTab(item.key);
                        }}
                        style={{
                            background: item.colorGrad,
                            borderRadius: '16px',
                            padding: '28px 24px',
                            color: '#ffffff',
                            boxShadow: item.shadow,
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            position: 'relative',
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            minHeight: '170px'
                        }}
                    >
                        {/* BACKGROUND WATERMARK ICON */}
                        <i
                            className={`fa ${item.icon}`}
                            style={{
                                position: 'absolute',
                                right: '-15px',
                                bottom: '-20px',
                                fontSize: '110px',
                                color: 'rgba(255, 255, 255, 0.15)',
                                pointerEvents: 'none'
                            }}
                        />

                        <div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                                <span style={{ fontSize: '13px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px', opacity: 0.95 }}>
                                    {item.title}
                                </span>
                                <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(255,255,255,0.22)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px' }}>
                                    <i className={`fa ${item.icon}`} />
                                </div>
                            </div>
                            <h2 style={{ fontSize: '42px', fontWeight: '900', margin: 0, color: '#ffffff', lineHeight: 1 }}>
                                {item.count}
                            </h2>
                        </div>

                        <div style={{ marginTop: '22px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '12.5px', fontWeight: '700', background: 'rgba(0,0,0,0.18)', padding: '8px 14px', borderRadius: '8px' }}>
                            <span>{item.badge}</span>
                            <i className="fa fa-arrow-right" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DashboardOverviewTab;
